import { render, staticRenderFns } from "./BattleUser.vue?vue&type=template&id=fbf29218&scoped=true&"
import script from "./BattleUser.vue?vue&type=script&lang=js&"
export * from "./BattleUser.vue?vue&type=script&lang=js&"
import style0 from "./BattleUser.vue?vue&type=style&index=0&id=fbf29218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf29218",
  null
  
)

export default component.exports